import React, { useRef } from "react";
import Xarrow from "react-xarrows";
import sampleImg1 from '../assets/images/PlayerScreen/myPic.jpg'
import sampleImg2 from '../assets/images/PlayerScreen/myPic1.png'
import pak from '../assets/images/PlayerScreen/pak.png'
import dia from '../assets/images/PlayerScreen/dia.png'
import crown from '../assets/images/PlayerScreen/crown.svg'
import Header from './Header'
import Footer from '../components/Footer'
import LeaderBackground from '../assets/images/PlayerScreen/LeaderBoardBackgroundLogo.svg'
import '../assets/css/PlayerSubScreen.css'
import '../assets/css/LeaderBoardSub.css'
import { useNavigate } from "react-router-dom";
import Host from "./Host";



const boxStyle = { border: "grey solid 2px", borderRadius: "10px", padding: "5px" };

function SimpleExample() {
  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  const box3Ref = useRef(null);
  const box4Ref = useRef(null);
  const box5Ref = useRef(null);
  const box6Ref = useRef(null);
  const box7Ref = useRef(null);
  const box8Ref = useRef(null);
  const box9Ref = useRef(null);
  const box10Ref = useRef(null);
  const box11Ref = useRef(null);
  const box12Ref = useRef(null);
  const navigate = useNavigate();


  const myStyle = {
    opacity: 0.5, // set the opacity to 50%
    width: "24%"
  };

const moveToChallange = ()=>{
console.log("challange1")
// navigate("/playerwaiting");
}

  return (

     

    <div className="leader-board-inner ">
      <Header />
      <div className="row d-flex justify-content-center mt-2 " style={{ color: "#D6A15E" }}><h3 className="p-0">LEADERBOARD</h3></div>
      <div className="px-3  pt-0 " style={{  display: "flex", justifyContent: "space-evenly", width: "100%", height:"63%" }}>

        <div className="row position-relative  px-0 leader-board-inner-border pt-2 mb-3 " style={{ width: "100%" }}>

          <div className="col-12">

            <div className="row">

              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-right" ref={box1Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row "  >

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1 '>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light '>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" ref={box3Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>


          <div className="col-12">

            <div className="row">

              <div className="col-2"> </div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-right" id="card2" style={{zIndex:"15"}} ref={box9Ref} onClick={moveToChallange}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" id="card3" style={{zIndex:"15"}} ref={box10Ref} onClick={moveToChallange}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"> </div>

            </div>

          </div>

          <div className="col-12 mb-2 ">

            <div className="row">

              <div className="col-2 ">
                <div className=" my-0 leader-board-tail-circle-right" ref={box2Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz Ff</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz Fff1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2">

              </div>
              <div className="col-2">


              </div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" ref={box4Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>

          {/* last three row  */}

          <div className="col-12">

            <div className="row">

              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-right" ref={box5Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" ref={box6Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>


          <div className="col-12">

            <div className="row">

              <div className="col-2"> </div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-right" id="card4" style={{zIndex:"15"}} ref={box11Ref} onClick={moveToChallange}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" id="card5" style={{zIndex:"15"}} ref={box12Ref} onClick={moveToChallange}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"> </div>

            </div>

          </div>

          <div className="col-12">

            <div className="row">

              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-right " ref={box7Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2"></div>
              <div className="col-2">
                <div className=" my-0 leader-board-tail-circle-left" ref={box8Ref}>

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>

          {/* center  */}


          <div className="col-12 mb-2 position-absolute leader-board-center-background" style={{ top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "100%" }}>

            <div className="row" >

              <div className="col-2 "> </div>
              <div className="col-2"></div>
              <div className="col-2">

                <div className=" my-0 "   id="card6" onClick={moveToChallange} >

                  <div className="player-screen-body-border" >

                    <div className="row " >

                      <div className="col-3 position-relative " >
                        <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>

              </div>
              <div className="col-2 "   >

                <div className=" my-0 " id="card7" onClick={moveToChallange} >

                  <div className="player-screen-body-border" >

                    <div className="row ">

                      <div className="col-3 position-relative ">
                        <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

                        <div className='position-absolute player-screen-card-crown pr-1'>
                          <img style={{marginLeft:"15%", marginTop:"15%"}} src={crown} alt="" />
                        </div>

                      </div>

                      <div className="col-9">

                        <div className='leader-board-card-div1  '>

                          <img player-screen-card-img1 src={pak} alt="" /> <span className='player-screen-card-text1 text-light'>Hafiz F</span>

                        </div>

                        <div className='leader-board-card-div2'>

                          <img player-screen-card-img2 src={dia} alt="" />  <span className='leader-board-card-text2 text-light'>Hafiz F1</span>

                        </div>


                      </div>

                    </div>

                  </div>

                </div>

              </div>
              <div className="col-2"></div>
              <div className="col-2"> </div>

            </div>

          </div>


          {/* host name */}

          <div className="col-12 position-absolute text-light" style={{ top: "88%", left: "51.5%", transform: "translate(-50%, -50%)" }}>

            <Host/>

          </div>

          {/* background logo  */}


          <div className="col-12 position-absolute text-light" style={{  top: "38%", left: "51.5%", transform: "translate(-50%, -50%)" }}>

<div className="row" style={{ width: "100%" }}>

  <div className="col-12 d-flex justify-content-center" >
    <img className="" style={myStyle} src={LeaderBackground} alt="" />
  </div>
  

</div>

{/* <div className="ml-0">
</div>
<div><p>Host Kareem</p></div> 
*/}

</div>


        </div>

        <Xarrow
          start={box1Ref} //can be react ref
          end="card2" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}

          showXarrow={true}
          headShape='arrow2'
        />

        <Xarrow
          start={box2Ref} //can be react ref
          end="card2" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}

          showXarrow={true}
          headShape='arrow2'
        />

        <Xarrow
          start={box3Ref} //can be react ref
          end="card3" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box4Ref} //can be react ref
          end="card3" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box5Ref} //can be react ref
          end="card4" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box6Ref} //can be react ref
          end="card5" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box7Ref} //can be react ref
          end="card4" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box8Ref} //can be react ref
          end="card5" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box9Ref} //can be react ref
          end="card6" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box10Ref} //can be react ref
          end="card7" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box11Ref} //can be react ref
          end="card6" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

        <Xarrow
          start={box12Ref} //can be react ref
          end="card7" //or an id
          lineColor={"#32C5B3"}
          headColor={"#32C5B3"}
          headSize={6}
          strokeWidth={1.5}
          // dashness={true}
          animateDrawing={1}
          curveness={0.9}
        />

      </div>
      {/* <div className="col-12 "><hr className='player-screen-body-text-line mt-2 mr-3 ml-3 ' /></div> */}

      <div className='col-12' style={{position:"fixed", bottom:"0", backgroundColor:"black"}}>
      
      <Footer BackPage="/playerwaiting" NextPage={"/challange"} />
    </div>
    </div>
  );
}

export default SimpleExample;